/* globals videojs */
'use strict';

var homePageUtils = require('../homePageUtils');
var atcWarantyModal = require('./addToCartModalWarranty');

/**
 * Updates PDP url while changing/selecting different variant in PLP tile
 *
 * @param {Object} $attrValue - Selected Attribute
 * @param {string} variantType - Type of Variant i.e. Condition/Color/Size
 * @param {Object} pdpUrlElementBtn - Multi variant multi value scenario - choose options button
 */
function updatePDPUrl($attrValue, variantType, pdpUrlElementBtn) {
    var selectedDataUrl = null;
    if (variantType === 'color') {
        selectedDataUrl = $attrValue.closest('.color-attribute-card-plp').attr('data-url');
    } else {
        selectedDataUrl = $attrValue.attr('data-url');
    }
    var pdpUrlElementImg = $attrValue.closest('.product-tile.product-detail').find('.image-container a');
    var currentPDPUrl = pdpUrlElementImg && pdpUrlElementImg.attr('href');
    var attrParam = selectedDataUrl && homePageUtils.getQueryString(selectedDataUrl).split('&')[0];
    var variantParam = null;
    if (variantType === 'condition') {
        var attrParamValue = attrParam && attrParam.split('=')[1];
        variantParam = variantType + '=' + attrParamValue;
    } else {
        variantParam = attrParam;
    }
    var updatedPDPUrl = null;
    if (currentPDPUrl && currentPDPUrl.includes('?')) {
        var originalPDPUrl = currentPDPUrl && currentPDPUrl.replace(currentPDPUrl.substring(currentPDPUrl.indexOf('?'), currentPDPUrl.length), '');
        updatedPDPUrl = originalPDPUrl + '?' + variantParam;
    } else {
        updatedPDPUrl = currentPDPUrl && (currentPDPUrl + '?' + variantParam);
    }
    pdpUrlElementImg.attr('href', updatedPDPUrl);
    if (pdpUrlElementBtn) {
        pdpUrlElementBtn.attr('href', updatedPDPUrl);
    }

    var moreLink = $attrValue.closest('.product-tile.product-detail').find('.more-variant');
    moreLink.attr('href', updatedPDPUrl);

    var productName = $attrValue.closest('.product-tile.product-detail').find('.product-tile-header a');
    productName.attr('href', updatedPDPUrl);

    var inStorePickup = $attrValue.closest('.product-tile.product-detail').find('a.in-store-pickup');
    inStorePickup.attr('href', updatedPDPUrl);
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('.size .condition-pricing .card[data-attr-value="' + attrValue.value + '"]');
        var $dataValue = $productContainer.find('.size .condition-pricing .card[data-attr-value="' + attrValue.value + '"]').attr('value');
        $attrValue.attr('data-url', $dataValue);

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            var pdpUrlElementBtn = $attrValue.closest('.tile-body').find('.choose-options-link');
            updatePDPUrl($attrValue, 'size', pdpUrlElementBtn);
        } else {
            $attrValue.removeClass('selected');
        }

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 */
function processBoxSelectionValues(attr, $productContainer, isOptionClicked) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            updatePDPUrl($attrValue, 'condition');
        } else {
            $attrValue.removeClass('selected');
        }

        if (attrValue.url) {
            $attrValue.data('url', attrValue.url);
        }

        if (attrValue.selectedVariantId) {
            $attrValue.data('condition-selected-variant-id', attrValue.selectedVariantId);
        }

        if (attrValue.price && attrValue.price.html) {
            var $priceSelector = $attrValue.find('.condition-prices div.price');
            if ($priceSelector.length) {
                $priceSelector.replaceWith(attrValue.price.html);
            }

            if ($productContainer.length && ($productContainer.hasClass('product-detail-redesign') && !isOptionClicked)) {
                var $priceUpdate = $('.price-update');
                var $priceOriginal = $('.card.selected .condition-prices').html();
                $priceUpdate.html($priceOriginal);
            }
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');
        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}
/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSwatchValues(attr, $productContainer) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchAnchor = $attrValue.parent();
        if (attrValue.selected) {
            $attrValue.addClass('selected');
            updatePDPUrl($attrValue, 'color');
        } else {
            $attrValue.removeClass('selected');
        }

        if (attrValue.url) {
            $swatchAnchor.attr('href', attrValue.url);
            $swatchAnchor.attr('data-url', attrValue.url);
        } else {
            $swatchAnchor.removeAttr('href');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} resources - resources to print labels
 * @param {integer} savingViolatorPercentage - percentage violator to show saving
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 */
function updateAttrs(attrs, $productContainer, resources, savingViolatorPercentage, isOptionClicked) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];
    var attrsWithBoxSelection = ['condition'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer);
        } else if (attrsWithBoxSelection.indexOf(attr.id) > -1) {
            processBoxSelectionValues(attr, $productContainer, isOptionClicked);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var ctaText = response.product.availability.buttonText;
    var showStorepickupText = $productContainer.find('.shiptohome-pickup');
    var addToCartButtonText = $productContainer.find('.add-to-cart-plp');
    if (!response.product.readyToOrder) {
        var unselectedMessage = response.product.unselectedVariationAttributes ? response.product.unselectedVariationAttributes : response.resources.info_selectforstock;
        if (unselectedMessage === 'ALL_ATTRS_SELECTED') {
            unselectedMessage = response.resources.info_notavailable_button;
        }
        ctaText = unselectedMessage;

        showStorepickupText.hide();
        addToCartButtonText.show();
        addToCartButtonText.prop('disabled', true);
    } else if (!response.product.available && response.product.allowBOPS && response.isBopsEnabledForWeb) {
        addToCartButtonText.hide();
        showStorepickupText.show();
    } else {
        showStorepickupText.hide();
        addToCartButtonText.show();
    }

    $('div.availability', response.$productContainer)
    .data('ready-to-order', response.product.readyToOrder)
    .data('available', response.product.available)
    .data('is-preorder', response.product.preorder)
    .data('is-stock', response.product.instock);

    $('button.add-to-cart-plp', $productContainer).empty().html(ctaText);
}
$('body').trigger('home:afterPageLoad');
/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 */
function handleVariantResponseOnPLP(response, $productContainer, isOptionClicked) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    var $redesignPriceinCart = $('.map-pricing-redesign');
    var $oldPriceinCart = $('.map-pricing');
    $productContainer.data('pid', response.product.id);
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources, response.savingViolatorPercentage, isOptionClicked);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);
            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
            $productContainer.parent('.bonus-product-item').data('is-preorder', response.product.preorder);
        }
        if ($redesignPriceinCart.length) {
            $redesignPriceinCart.empty().html($oldPriceinCart.text());
            $oldPriceinCart.empty();
        }
    }

    updateAvailability(response, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length ?
            $('.prices .price', $productContainer) :
            $('.prices .price');
        if (response.product.seePriceInCart) {
            $priceSelector.html('<span class="sales"><span class="value">' + response.resources.info_seeincart + '</span></span>');
        } else if (!($productContainer.hasClass('product-detail-redesign') && isOptionClicked)) {
            $priceSelector.replaceWith(response.product.price.html);
        }
    }

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer
        });
    } else {
        var $availability = $('div.availability');
        var availableOnline = $($availability, $productContainer).data('available');
        var readyToOrder = $($availability, $productContainer).data('ready-to-order');
        var $addToCartButton = $('button.add-to-cart-plp', $productContainer);

        if (readyToOrder && availableOnline) {
            $addToCartButton.attr('disabled', false);
        } else {
            $addToCartButton.attr('disabled', true);
        }
    }

    // update release date
    if (response.product.releaseDate) {
        $productContainer.find('.pdp-release-date').empty().html(response.product.releaseDate).removeClass('d-none');
    } else if (response.product.releaseDate === null) {
        $productContainer.find('.pdp-release-date').empty().addClass('d-none');
    }

    // update street date guarantee
    if (response.product.streetDateGuarantee && response.product.streetDateGuarantee.showStreetDateGuarantee && response.product.streetDateGuarantee.html) {
        $productContainer.find('.product-street-date-guarantee-section').empty().html(response.product.streetDateGuarantee.html).removeClass('d-none');
    } else {
        $productContainer.find('.product-street-date-guarantee-section').empty().addClass('d-none');
    }
}
/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {boolean} isOptionClicked - Warranty recommendation clicked
 */
function attributeSelectOnPlp(selectedValueUrl, $productContainer, isOptionClicked) {
    if (selectedValueUrl) {
        var url = selectedValueUrl;

        // add edit card UUID
        var uuid = $productContainer.find('.update-cart-url').data('uuid');
        if (uuid) {
            url = homePageUtils.appendParamToURL(url, 'uuid', uuid);
        }

        $('body').trigger('product:beforeAttributeSelect', {
            url: url,
            container: $productContainer,
            optionElement: isOptionClicked
        });

        var rtQueryStringValue = $('#rtquerystring').val();
        url = homePageUtils.appendParamToURL(url, 'rt', rtQueryStringValue);
        url = homePageUtils.appendParamToURL(url, 'hidePriceMAP', true);
        var $fadeAddToCartBtn = $productContainer.find('.add-to-cart-plp-buttons .add-to-cart-plp, .add-to-cart-plp-buttons .shiptohome-pickup');
        $fadeAddToCartBtn.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            success: function (data) {
                handleVariantResponseOnPLP(data, $productContainer, isOptionClicked);
                $('body').trigger('product:afterAttributeSelect', {
                    data: data,
                    container: $productContainer
                });

                if ($('.product-detail').hasClass('product-detail-redesign') || $('.home-page-redesign').length) {
                    var $storeVariantPricing = $($productContainer).find('.conditions-pricing-on-plp');
                    var $priceOnSelectedVariant = $($productContainer).find('.condition .condition-pricing');
                    var $pricingOnVariant = $priceOnSelectedVariant.html();
                    $storeVariantPricing.html($pricingOnVariant);
                }

                if ($productContainer.find('a.more-variant').length > 1) {
                    $productContainer.find('a.more-variant')[1].remove();
                }

                if ($productContainer.find('a.more-variant-count').length > 1) {
                    $productContainer.find('a.more-variant-count')[1].remove();
                }

                if ($('.account-dashboard-wishlist').length) {
                    let $pointsSection = $($productContainer).find('.product-tile-points .points-section');
                    let $variantPricing = $($productContainer).find('.conditions-pricing-on-plp');
                    let $selectedVariantPrice = $($productContainer).find('.condition .condition-pricing');
                    let $priceOnVariant = $selectedVariantPrice.html();
                    $variantPricing.html($priceOnVariant);
                    if ($pointsSection) {
                        let newPoints = 0;
                        if ($pointsSection.hasClass('pro')) {
                            newPoints = data.product.proDayPoints;
                        }
                        if ($pointsSection.hasClass('player')) {
                            let multiplier = parseInt($('#playerMembershipPointsMultiplier').val(), 10);
                            let currentPrice = data.product.price.sales.value;
                            newPoints = parseInt(Math.round(currentPrice * multiplier), 10);
                        }
                        let str = 'pts';
                        let result = str.sup();
                        let updatedPointsVariant = newPoints + result;
                        let $currentPointsVariant = $pointsSection.find('.membership-points');
                        $currentPointsVariant.html(updatedPointsVariant);
                    }
                }
                var selectedPriceContainer = $($productContainer).find('.conditions-pricing-on-plp .condition-attribute-card-plp.selected');
                var saleBadge = selectedPriceContainer.find('.badge-container-redesign .sale-indicator');
                var promotionBadge = selectedPriceContainer.find('.badge-container-redesign .badge-indicator');
                if (saleBadge.length && promotionBadge.length) {
                    saleBadge.hide();
                }

                $fadeAddToCartBtn.spinner().stop();
            },
            error: function () {
                $fadeAddToCartBtn.spinner().stop();
            }
        });
    }
}

/**
 * @param {Object} currentObject - current object
 */
function showSPAMessage(currentObject) {
    var messageType = $('#spa-alert').val();
    var selector = currentObject.closest('.add-to-cart-plp-buttons');
    if (messageType === 'null') {
        currentObject.attr('disabled', true);
    } else {
        currentObject.attr('disabled', true);
        var recentlyclicked = currentObject.closest('.product.grid-tile').index();
        var $pdpContainer = $('.product-detail-redesign');
        if (recentlyclicked === 0 && $pdpContainer) {
            console.log('first');
            $('.primary-details-row').find('.add-to-cart-buttons .add-to-cart').attr('disabled', true);
            $('.sticky-header').find('.add-to-cart-buttons .add-to-cart').attr('disabled', true);
        }
        if (selector.find('.add-to-cart-messages-spa').length === 0) {
            selector.append(
            '<div class="add-to-cart-messages-spa"></div>'
            );
        }
        selector.find('.add-to-cart-messages-spa').append(
            '<div class="alert add-to-basket-alert text-center" role="alert">'
            + messageType
            + '</div>'
        );
        setTimeout(function () {
            $('.add-to-cart-messages-spa').remove();
        }, 5000);
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button, also
 * shows "Add to Cart" modal
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {Object} currentObject - current object
 */
function handlePostCartAdd(response, currentObject) {
    $('.minicart').trigger('count:update', response);
    $('.minicart').trigger('minicartheader:update');
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        console.log('test');
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        if ($('.pur-renew-modal').length > 0) {
            $('.add-to-cart-messages').append(
                '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' +
                '<div class="alert-msg">' + response.message + '</div>' +
                response.cartLink +
                '</div>'
            );
        } else if (response.enableAddToCartModal) {
            if ($('.product-detail').length && $('.quick-view-dialog').length === 0 && response.error) {
                var currentAtcBtn = currentObject.closest('.add-to-cart-plp-buttons');
                currentAtcBtn.prepend(
                    '<div class="alert ' + messageType + ' add-to-basket-inline text-center" role="alert">' +
                    '<div class="alert-msg">' + response.message + '</div>' +
                    response.cartLink +
                    '</div>'
                );
            } else if (response.error) {
                $('.add-to-cart-messages').append(
                    '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' +
                    '<div class="alert-msg">' + response.message + '</div>' +
                    response.cartLink +
                    '</div>'
                );
            }
        } else {
            // eslint-disable-next-line
            if ($('.product-detail').length && $('.quick-view-dialog').length === 0) {
                var selector = currentObject.closest('.add-to-cart-plp-buttons');
                selector.prepend(
                    '<div class="alert ' + messageType + ' add-to-basket-inline text-center" role="alert">' +
                    '<div class="alert-msg">' + response.message + '</div>' +
                    response.cartLink +
                    '</div>'
                );
            } else {
                $('.add-to-cart-messages').append(
                    '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' +
                    '<div class="alert-msg">' + response.message + '</div>' +
                    response.cartLink +
                    '</div>'
                );
            }
        }

        setTimeout(function () {
            $('.add-to-basket-alert, .add-to-basket-inline').remove();
        }, 5000);
    }

    if (response.enableAddToCartModal && response.addedToCartModalMarkup != null) {
        if ($('#addedToCartModal').length) {
            $('#addedToCartModal').remove();
            $('.modal-backdrop').remove();
        }

        var $addedToCartModalMarkup = $($.trim(response.addedToCartModalMarkup));

        $('body').append($addedToCartModalMarkup);
        $('#addedToCartModal').modal('show');
        $('body').trigger('product:afterAddToCartModal');

        if ($('.redesign-atcmodal').find('#addedToCartModal').length === 1) {
            atcWarantyModal.handleATCModalWarranty();
        }

        var promotionRecommendationUrl = $('.promotion_recommendation').data('url');
        if (promotionRecommendationUrl) {
            $.ajax({
                url: promotionRecommendationUrl,
                type: 'get',
                success: function (data) {
                    $('.promotion_recommendation').html(data);
                    $('.promotion_recommendation .recommended-products-caro').slick(homePageUtils.recommendedProductsRedesignATC);
                }
            });
        }
    }
}

/**
 * Updates the variants card/swatches based on multi-variants or multi-variant,multi-value
 */
function loadVariantsOnRecommTiles() {
    var $tiles = $('.product-tile.product-detail');
    if ($tiles.length) {
        $tiles.each(function (index) {
            var currentTile = $($tiles[index]);
            var variantContainer = currentTile.find('.variant-options');
            var variantTypes = variantContainer && variantContainer.children() && variantContainer.children().length;
            var selectedConditionElement = currentTile && currentTile.find('.condition .condition-attribute-card-plp.selected');
            if (variantTypes > 1) {
                var conditionContainer = currentTile && currentTile.find('.condition');
                var conditionTypes = conditionContainer && conditionContainer.find('.condition-attribute-card-plp');
                if (conditionTypes.length) {
                    var $restVariants = variantContainer.children().not('.condition');
                    var addToCartBtn = currentTile.find('.add-to-cart-plp-buttons');
                    var chooseOptionsBtn = currentTile.find('.choose-options-link');
                    if (conditionTypes.length > 1) {
                        $restVariants.hide();
                        addToCartBtn.hide();
                        chooseOptionsBtn.show();
                        updatePDPUrl(selectedConditionElement, 'condition', chooseOptionsBtn);
                    } else {
                        conditionContainer.hide();
                        var secondaryVariantType = $($restVariants[0]).attr('data-attr');
                        var selectedColorElement = null;
                        var selectedSizeElement = null;
                        if (secondaryVariantType === 'color') {
                            selectedColorElement = currentTile.find('.color .color-attribute-card-plp .color-value.selected').parent();
                            updatePDPUrl(selectedColorElement, 'color', null);
                        } else if (secondaryVariantType === 'size') {
                            selectedSizeElement = currentTile.find('.size-attribute-card-plp.selected');
                            updatePDPUrl(selectedSizeElement, 'size', null);
                        }
                        if ($restVariants.length && $restVariants.length > 1) {
                            $restVariants.not($restVariants[0]).hide();
                            addToCartBtn.hide();
                            chooseOptionsBtn.show();
                            if (secondaryVariantType === 'color') {
                                updatePDPUrl(selectedColorElement, 'color', chooseOptionsBtn);
                            } else if (secondaryVariantType === 'size') {
                                updatePDPUrl(selectedSizeElement, 'size', chooseOptionsBtn);
                            }
                        }
                    }
                }
            } else {
                updatePDPUrl(selectedConditionElement, 'condition', null);
            }
        });
    }
}

// To update recommendation tiles on load
$(document).on('product:updateVariantsOnTiles', function () {
    loadVariantsOnRecommTiles();
});

$(window).on('load', function () {
    $(document).trigger('product:updateVariantsOnTiles');
});

/**
 * Update DOM with hide color and size labels
 *
 * @return {undefined}
 */
function hiddenColorSizeLabel() {
    $('.color-label').hide();
    $('.size-label').hide();
}

/**
 * returns component Name using the zoneSource (Analytics)
 * @param {string} zoneSource - zoneSource for addToCart from Recommendation section
 * @return {string} - returns componentName
 */
function getComponentDetails(zoneSource) {
    switch (zoneSource) {
        case 'PDP ATC Modal' :
        case 'PDP' : return 'More Like This';
        case 'Search Result' :
        case 'PLP': return 'You Might Also Like';
        case 'Home' :
        case 'console Landing':
        case 'Sales Landing':
        case 'Franchise Landing': return 'Recommended Products';
        default: return 'Recommended Products';
    }
}

module.exports = {

    hidelabels: function () {
        hiddenColorSizeLabel();
    },
    addToCart: function addToCart() {
        $(document).on('click', 'button.add-to-cart-plp, button.add-to-cart-global', function (e) {
            e.preventDefault();
            var curatedFlag = $(this).closest('.curated-promo-component').length;
            var isStyleCurated = $(this).closest('.curated-promo-component').find('.curated-container').attr('style');
            var titleImage;
            var curatedComponentDetails;
            if (isStyleCurated && isStyleCurated.length) {
                var backgroundImageArray = isStyleCurated.split('/');
                titleImage = backgroundImageArray[backgroundImageArray.length - 1].split('.');
                curatedComponentDetails = 'Curated Promotions | ' + titleImage[0] + ' | cross-sell';
            }
            if (curatedFlag & !isStyleCurated) {
                var curatedTitle = $(this).closest('.curated-promo-component').find('.curated-container .title').text();
                var curatedSubtitle = $(this).closest('.curated-promo-component').find('.curated-container .subtitle').text();
                curatedComponentDetails = 'Curated Promotions | ' + curatedTitle + ' | ' + curatedSubtitle + ' | cross-sell';
            }
            var addToCartUrl;
            var pid;
            var pidsObj;
            var lastAddedMasterProductId = $(this).closest('.product.grid-tile').data('pid');

            var $currentObject = $(this);
            $('body').trigger('product:beforeAddToCart', this);
            var $stickyAddToCart = $('.sticky-header .add-to-cart');
            $stickyAddToCart.spinner().stop();
            pid = $(this).closest('.product-detail:not(".bundle-item")').data('pid');
            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }
            var pdName = $(this).data('gtmdata');
            var productName = pdName.productInfo.name;
            var zoneSource = $(this).data('zonesource');
            var pdpComponentName = $(this).data('rec-componentname-pdp');
            addToCartUrl = $('.add-to-cart-url-plp').val();
            addToCartUrl = homePageUtils.appendParamToURL(addToCartUrl, 'productID', pid);
            var form = {
                pid: pid,
                pidsObj: pidsObj,
                quantity: 1
            };
            var $btnAddToCartSpinner = $productContainer.find('.add-to-cart-plp-buttons .add-to-cart-plp, .add-to-cart-plp-buttons .shiptohome-pickup');
            if (zoneSource) {
                form.pageSpecified = zoneSource;
            } else {
                form.pageSpecified = 'PLP';
                zoneSource = 'PLP';
            }
            form.recentCheck = true;
            if ($(this).parents('.js-morelikethis').length > 0) {
                var moreLike = $(this).parents('.js-morelikethis');
                form.addToCartSource = $.trim(moreLike.find('h3').text());
            } else if ($(this).parents('.js-peoplealsobought').length > 0) {
                var peopleAlso = $(this).parents('.js-peoplealsobought');
                form.addToCartSource = $.trim(peopleAlso.find('h3').text());
            } else if ($(this).parents('.js-recommendedproducts').length > 0) {
                form.addToCartRecommendation = 'Recommended Products';
                form.listNameRecommendation = window.pageContext.pageType;
            } else if ($(this).parents('.last-visited-redesign').length > 0) {
                var lastVisited = $(this).parents('.last-visited-redesign');
                form.addToCartSource = $.trim(lastVisited.find('h3').text());
            } else if (pdpComponentName) {
                form.addToCartRecommendation = pdpComponentName;
            } else {
                form.addToCartRecommendation = getComponentDetails(zoneSource);
            }
            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $btnAddToCartSpinner.spinner().start();
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        if (data.Response && data.Response === 'addtoCartWR') {
                            showSPAMessage($currentObject);
                            $('body').trigger('product:afterAddToCartSPA', productName);
                        } else {
                            handlePostCartAdd(data, $currentObject);
                        }
                        window.lastAddedMasterProductId = lastAddedMasterProductId;
                        hiddenColorSizeLabel();
                        $('body').trigger('product:afterAddToCartDetails', { data: data, label: 'plp' });
                        setTimeout(function () {
                            $('body').trigger('product:afterAddToCart', [data, curatedFlag, curatedComponentDetails]);
                        }, 3000);
                        $btnAddToCartSpinner.spinner().stop();
                    },
                    error: function () {
                        $btnAddToCartSpinner.spinner().stop();
                    }
                });
            }
        });
    },
    conditionAttribute: function () {
        $(document).on('click', '.condition-attribute-card-plp, .size-attribute-card-plp, .color-attribute-card-plp', function (e) {
            e.preventDefault();

            if ($(this).hasClass('selected') || $(this).hasClass('disabled') || $(this).hasClass('unselectable')) {
                return;
            }

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelectOnPlp($(this).data('url'), $productContainer);
            hiddenColorSizeLabel();
        });
    }
};
